import { Field, ErrorMessage, FieldProps } from 'formik';
import { DatePicker as AntDatePicker, Flex } from 'antd';
import dayjs from 'dayjs';
import TextError from 'components/TextError';
import FieldLabel from 'components/FieldLabel';
import If from 'components/If';
import { DatePickerProps } from 'utils/globalTypes';

function DatePicker(props: DatePickerProps) {
  const {
    label,
    name,
    qaSelector = {},
    showErrMsg = true,
    info,
    ...rest
  } = props;
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <FieldLabel label={label} info={info} />
      <Field name={name}>
        {({ field, meta, form }: FieldProps) => {
          const { setFieldValue, setFieldTouched } = form;
          const { value } = field;
          const fieldStatus = meta.touched && meta.error ? 'error' : '';
          const onBlur = () => {
            setFieldTouched(name, true);
          };
          const onChange: DatePickerProps['onChange'] = (_, dateString) => {
            const date =
              typeof dateString === 'string' ? dateString : dateString[0];
            setFieldValue(name, date ? dayjs(date).format('YYYY-MM-DD') : '');
          };
          return (
            <AntDatePicker
              className='fullWidth'
              status={fieldStatus}
              id={name}
              name={name}
              defaultValue={value ? dayjs(value) : null}
              {...rest}
              onChange={onChange}
              onBlur={onBlur}
              data-qa-selector={qaSelector}
            />
          );
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => <TextError msg={msg} qaSelector={`${qaSelector}-error`} />}
        </ErrorMessage>
      </If>
    </Flex>
  );
}

export default DatePicker;
